import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../../lib/site";

export const WhatsAppFab = () => (
  <a href={waLink()} target="_blank" rel="noopener noreferrer" aria-label="Falar no WhatsApp" data-testid="floating-whatsapp-btn"
    className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105">
    <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-25" />
    <MessageCircle className="relative h-7 w-7" strokeWidth={2.5} />
  </a>
);

const KEY = "cc_cookie_ok";

export const CookieBanner = () => {
  const [show, setShow] = useState(() => !localStorage.getItem(KEY));
  if (!show) return null;
  const accept = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  return (
    <div className="fixed inset-x-3 bottom-24 z-50 rounded-[20px] border border-[#C8D7E4] bg-[#F7F5F0] p-4 shadow-xl sm:bottom-5 sm:left-5 sm:right-24 sm:flex sm:items-center sm:justify-between sm:gap-6 sm:py-3"
      role="dialog" aria-label="Aviso de cookies" data-testid="cookie-banner">
      <p className="text-sm leading-relaxed text-[#15579A]">
        Usamos cookies essenciais para o funcionamento do site e para entender como ele é usado, conforme a LGPD.
      </p>
      <button onClick={accept} data-testid="cookie-banner-accept-btn"
        className="mt-3 shrink-0 rounded-full bg-[#196ABC] px-5 py-2 text-sm font-semibold text-[#F7F5F0] transition-colors hover:bg-[#218FFF] sm:mt-0">
        Entendi
      </button>
    </div>
  );
};
